module.exports = __webpack_public_path__ + "img/steamred.d8183f4a.svg";